import { useDispatch, useSelector } from "react-redux";
import Link from "next/link";
import { IconNotebook } from "@tabler/icons-react";

import { Button, Card } from "@chef/components";
import {
  hideFavoriteModal,
  selectRecipeActionModalIsOpen,
} from "@chef/state-management";
import { BRAND_PATHS } from "@chef/constants";

import { Modal } from "./modal/Modal";

import { intl } from "./RecipeActionModal.Intl";

export const RecipeActionModal = () => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    dispatch(hideFavoriteModal());
  };

  const recipeActionModalOpen = useSelector(selectRecipeActionModalIsOpen);

  return (
    <Modal
      open={recipeActionModalOpen}
      onClose={handleCancel}
      size="md"
      interactions={[["top-close-button", "enabled"]]}
    >
      <Card
        noPadding
        className="flex flex-col items-center p-6 mt-20 text-center md:p-18"
      >
        <div className="flex items-center justify-center w-20 h-20 rounded-full bg-grey-3">
          <IconNotebook width={48} height={48} />
        </div>
        <h1 className="max-w-xs mt-4 mb-2 text-xl md:text-2xl">
          <strong>{intl.LOG_IN_TO_CUSTOMIZE_YOUR_RECIPES}</strong>
        </h1>

        <p className="mb-8">
          {intl.AS_OUR_CUSTOMER_YOU_CAN_CREATE_YOUR_OWN_COOKBOOK}
        </p>

        <Link href={BRAND_PATHS.LOG_IN_URL} className="w-full">
          <Button primary className="mb-3" full onClick={handleCancel}>
            {intl.LOG_IN_OR_CREATE_AN_ACCOUNT}
          </Button>
        </Link>

        <Button onClick={handleCancel} outlined full>
          {intl.NO_THANK_YOU}
        </Button>
      </Card>
    </Modal>
  );
};
